import { Drawer, Spin, Tooltip } from '@didi-pebble/pebble-design-react';
import { i18nTranslate } from '@didi/i18n-plugin';
import { useAtomValue } from 'jotai';
import { useEffect, useState } from 'react';

import { ReactComponent as ClomsImg } from '@/assets/images/close.svg';
import { CommonApi } from '@/api/common';
import { loginInfoAtom } from '@/store/common';
import customerServe from '@/assets/images/customerServe.png';
import { Omega } from '@/lib';
import { useIsMobile } from '@/utils';

import styles from './index.module.less';

const CsInfo = (props: { onlyIcon?: boolean }) => {
  const isMobile = useIsMobile();
  const { onlyIcon } = props;
  const loginInfo: any = useAtomValue(loginInfoAtom);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [url, setUrl] = useState<string>('');
  const handleMouseEnter = () => {
    Omega.trackEvent('bt_gd_gas_station_business_cs_time_bubble_sw', '客服气泡展示', {
      user_id: loginInfo?.uid,
      country_code: loginInfo?.country_code
    });
  };
  const getCsConfig = async () => {
    try {
      setLoading(true);
      const { data } = await CommonApi.getCsUrl();

      setUrl(data?.cx_jump_link);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCsConfig();
  }, []);

  return (
    <div onMouseEnter={handleMouseEnter}>
      {onlyIcon ? (
        <div
          className='h-[48px] flex items-center'
          onClick={() => {
            if (url) {
              setOpen(true);
            }
          }}
        >
          <img src={customerServe} width={16} height={16} />
        </div>
      ) : (
        <Tooltip
          title={<div>{i18nTranslate('Internal_Tools_3_IpMC_owwp')}</div>}
          placement='bottom'
        >
          <div
            className={styles.pop_over}
            onClick={() => {
              if (url) {
                setOpen(true);
              }
            }}
          >
            <div className='px-[8px] flex items-center rounded font-DiDiSansPro-Medium text-xs'>
              <img src={customerServe} width={20} height={20} className='mr-[8px] shrink-0' />
              <div>
                <div className={`font-medium `}>{i18nTranslate('Internal_Tools_2_KOqv_srKp')}</div>
                <div className={`text-xs`}>{i18nTranslate('Internal_Tools_3_Cdzx_KDff')}</div>
              </div>
            </div>
          </div>
        </Tooltip>
      )}
      {url && (
        <Drawer
          className={styles.drawer_cs}
          width={isMobile ? '100%' : 446}
          closeIcon={null}
          placement='right'
          onClose={() => {
            setOpen(false);
          }}
          open={open}
        >
          <ClomsImg
            className='w-4 h-4 absolute right-5 top-4 cursor-pointer'
            onClick={() => {
              setOpen(false);
            }}
          ></ClomsImg>
          {loading ? (
            <div className='h-full flex items-center justify-center'>
              <Spin spinning={loading}></Spin>
            </div>
          ) : (
            <div className='h-full'>
              {url ? (
                <iframe className='w-full h-full' src={url}></iframe>
              ) : (
                <div className='w-full h-full'></div>
              )}
            </div>
          )}
        </Drawer>
      )}
    </div>
  );
};

export default CsInfo;
